var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.0078 2.25781H1.99219C0.893695 2.25781 0 3.15151 0 4.25V12.75C0 13.8485 0.893695 14.7422 1.99219 14.7422H15.0078C16.1063 14.7422 17 13.8485 17 12.75V4.25C17 3.15151 16.1063 2.25781 15.0078 2.25781ZM15.6719 12.75C15.6719 13.1162 15.374 13.4141 15.0078 13.4141H1.99219C1.62602 13.4141 1.32812 13.1162 1.32812 12.75V4.25C1.32812 3.88384 1.62602 3.58594 1.99219 3.58594H15.0078C15.374 3.58594 15.6719 3.88384 15.6719 4.25V12.75Z","fill":"#04B3C0","key":0}),React.createElement("path",{"d":"M15.5594 3.08581L8.50025 8.33644L1.44113 3.08581L0.648438 4.15146L8.50025 9.99168L16.3521 4.15146L15.5594 3.08581Z","fill":"#04B3C0","key":1})]);
}

Email.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Email;

Email.default = Email;
